import {
  SuggestedReviewers as SuggestedReviewersIcon,
  NoSendReviewers as NoSendReviewersIcon,
  BioethicalApprovals as BioethicalApprovalsIcon,
} from "./../../Components/Icon";
import { navigationMapBuilder } from "./helpers";
import SuggestedReviewers from "./../../Pages/Miscellaneous/SuggestedReviewers";
import NoSendReviewers from "./../../Pages/Miscellaneous/NoSendReviewers";
import EthicalApprovals from "./../../Pages/Miscellaneous/EthicalApprovals";

const navigation = () => ([
  {
    header: "Miscellaneous",
    links: [
      {
        text: "Suggested Reviewers",
        icon: SuggestedReviewersIcon,
        route: "suggestedreviewers",
        component: SuggestedReviewers,
      },
      {
        text: "Reviewers(Not to send)",
        icon: NoSendReviewersIcon,
        route: "nosendreviewers",
        component: NoSendReviewers,
      },
      {
        text: "Bioethical approvals",
        icon: BioethicalApprovalsIcon,
        route: "bioethicalapprovals",
        component: EthicalApprovals,
      },
    ],
  },
]);

const navigationMap = (parentRoute) =>
  navigationMapBuilder(parentRoute, navigation);

export default navigationMap;
